module.exports = __webpack_public_path__ + "static/media/medpro_circle.dc9c7663.svg";